export default __webpack_public_path__ + "static/media/1643.c66c8df9.png";